
<template>
  <BaseNew
    @new-open-action="loadServerEntry"
    ref="baseNew"
    width="70%"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :inlineAddButton="inlineAddButton"
    :addButtonIcon="addButtonIcon"
    :showButton="showButton"
    :hideSaveButton="hideSaveButton"
    :newCreateButtonLabel="newCreateButtonLabel"
    :newTitle="title"
  >
    <template slot="newForm">
      <Index :customerName="person.name"></Index>
    </template>
    
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from './form.vue';
import BaseNew from "@shared_components/base_new.vue";
import Index from "./index.vue";

export default {
  data() {
    return {
      error: null,
      loading: false,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    title: {
      type: String,
      default: "Visualizar Visitas"
    },
    person: {
      type: Object,
      default: null,
    },
    inlineAddButton: {
      type: Boolean,
      default: true
    },
    newButton: {
      type: Boolean,
      default: false,
    },
    addButtonIcon: {
      type: String,
      default: "mdi-calendar-clock-outline"
    },
    modelNameSingular: {
      type: String,
      default: "Visualizar visitas"
    },
    parentId: {
      type: String,
      default: null,
    },
    showButton:{
      type: Boolean,
      default: true,
    },
    hideSaveButton:{
      type: Boolean,
      default: true,
    },
    newCreateButtonLabel: {
      type: String,
      default: function() {
        return this.modelNameSingular
      }
    },
  },
  components: {
    Form: Form,
    BaseNew: BaseNew,
    Index: Index,
  },
  created(){
    // console.log(this.person);
  },
  methods: {
    loadServerEntry: function() {
      // this.error = null;
      // this.loading = true;
      // this.$apollo
      //   .query({
      //     query: LOAD_NEW_AGENDA_QUERY,
      //     fetchPolicy: "no-cache",
      //     variables:{
      //       parentId: this.parentId,
      //     }
      //   })
      //   .then(response => {
      //     this.entry = response.data.accountContext.agenda;
      //     this.extraData = response.data;
      //   })
      //   .catch(response => console.log(response))
      //   .finally(() => (this.loading = false));

    },
    createServerEntry: function(agenda) {
      // console.log("SUBCULTURE", agenda, this.entry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(agenda, this.entry.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: CREATE_AGENDA_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(agenda, this.entry.validations)
          }
        })
        .then(response => {
          var errors = response.data.createAgenda.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created", response.data.createAgenda.agenda);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_AGENDA_QUERY = gql `
  query($parentId: ID){
    accountContext{
      agenda(parentId: $parentId) {
        id
        personId
        customerId
        destinyAddressId
        parentId
        validations
      }
      agendaStatuses
      agendaPriorityTypes
      agendaContacts
      allMyEmployees{
        id
        name
      }
      allMyCustomers{
        id
        name
        sellerId
      }
    } 
  }
`;

const CREATE_AGENDA_MUTATION = gql `
  mutation($input: AgendaCreateInputObject!) {
    createAgenda(input: $input) {
      agenda {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>

